// extracted by mini-css-extract-plugin
module.exports = {"burger-menu":"styles-m__burger-menu__1agmT"};